import { IFeedState, IFilter, IState } from '../../models/states';
import actionTypes from '../../utilities/actionTypes';
import store from '../reducers/index';
export interface ISetAssetsFilters {
  type: actionTypes.SET_ASSETS_FILTERS;
  payload: any;
  feeds: IFeedState;
}
export interface ISetAssetsFiltersFirstTime {
  type: actionTypes.SET_ASSETS_FILTERS_FIRST_TIME;
  payload: any;
  feeds: IFeedState;
}
export interface ISetMissingAssetsFilters {
  type: actionTypes.SET_MISSING_ASSETS_FILTERS;
  payload: any;
  appState: IState;
}
export interface ISetPlaylistFilters {
  type: actionTypes.SET_PLAYLIST_FILTER;
  payload: any;
}
export interface ISetPlaylistsFiltersFirstTime {
  type: actionTypes.SET_PLAYLISTS_FILTERS_FIRST_TIME;
  payload: any;
}
export interface ISetScreenFilters {
  type: actionTypes.SET_SCREEN_FILTERS;
  payload: any;
}
export interface ISetUserFilters {
  type: actionTypes.SET_USER_FILTERS;
  payload: any;
  appState: IState;
}
export interface ISetPlaylistFilters {
  type: actionTypes.SET_PLAYLIST_FILTER;
  payload: any;
}

export interface IUpdateFilters {
  type: actionTypes.UPDATE_FILTERS;
  filterType: string; // user, screen , agent
  filterName: string;
  filter: IFilter; // actual filter value
}

export interface IRestoreFilters {
  type: actionTypes.RESTORE_FILTERS;
}

export const setAssetsFilters = (payload: any): ISetAssetsFilters => {
  return {
    type: actionTypes.SET_ASSETS_FILTERS,
    payload,
    feeds: store.getState().feeds
  };
};

export const setAssetsFiltersFirstTime = (
  payload: any
): ISetAssetsFiltersFirstTime => {
  return {
    type: actionTypes.SET_ASSETS_FILTERS_FIRST_TIME,
    payload,
    feeds: store.getState().feeds
  };
};
export const setMissingAssetsFilters = (
  payload: any
): ISetMissingAssetsFilters => {
  return {
    type: actionTypes.SET_MISSING_ASSETS_FILTERS,
    payload,
    appState: store.getState()
  };
};

export const setScreenFilters = (payload: any): ISetScreenFilters => {
  return {
    type: actionTypes.SET_SCREEN_FILTERS,
    payload
  };
};

export const setUserFilters = (payload: any): ISetUserFilters => {
  return {
    type: actionTypes.SET_USER_FILTERS,
    payload,
    appState: store.getState()
  };
};

export const restoreFilters = (): IRestoreFilters => {
  return {
    type: actionTypes.RESTORE_FILTERS
  };
};
export const setPlaylistFilters = (payload: any): ISetPlaylistFilters => {
  return {
    type: actionTypes.SET_PLAYLIST_FILTER,
    payload
  };
};
export const setPlaylistFiltersFirstTime = (
  payload: any
): ISetPlaylistsFiltersFirstTime => {
  return {
    type: actionTypes.SET_PLAYLISTS_FILTERS_FIRST_TIME,
    payload
  };
};

export const updateFilters = (
  filterType: string,
  filterName: string,
  filter: IFilter
): IUpdateFilters => {
  return {
    type: actionTypes.UPDATE_FILTERS,
    filterType,
    filterName,
    filter
  };
};
export type IFilterActions =
  | ISetAssetsFilters
  | ISetMissingAssetsFilters
  | ISetScreenFilters
  | ISetUserFilters
  | ISetAssetsFiltersFirstTime
  | IRestoreFilters
  | IUpdateFilters
  | ISetPlaylistFilters
  | ISetPlaylistsFiltersFirstTime;
